import React from "react";
import { Link } from "react-router-dom";
import { MailIcon, PhoneIcon } from "lucide-react";
import { Logo } from "../ui/Logo";
import { NewsletterForm } from "./NewsletterForm";
import { CONTACT, SOCIALS } from "../../data/site";
import { FOOTER_CLIENTS, FOOTER_LEGAL, FOOTER_STUDIO } from "../../data/navigation";
import { SERVICES } from "../../data/services";
const socialMarks: Record<string, string> = {
  Instagram: "IG",
  Facebook: "FB",
  LinkedIn: "in",
  X: "X"
};
function Column({
  title,
  links
}: {
  title: string;
  links: {
    label: string;
    href: string;
  }[];
}) {
  return <div data-id="element-259" data-mp="3n3audcq71yyy">
      <p className="t-eyebrow mb-5 text-muted" data-id="element-260" data-mp="3n32fxgefalln">{title}</p>
      <ul className="grid gap-1" data-id="element-261" data-mp="3n1hldqs3z2ns">
        {links.map(l => <li key={l.href} data-id="element-262" data-mp="3j30cp2t1hk49">
            <Link to={l.href} className="inline-flex min-h-[36px] items-center text-[15px] text-fg-2 transition-colors duration-150 ease-out hover:text-fg" data-id="element-263" data-mp="3j3tmkcnaopqm">
              {l.label}
            </Link>
          </li>)}
      </ul>
    </div>;
}
export function Footer() {
  const serviceLinks = SERVICES.map(s => ({
    label: s.name.replace(" Websites", ""),
    href: `/services/${s.slug}`
  }));
  return <footer className="border-t border-line bg-ink-2" data-id="element-264" data-mp="2p5xsvld7mwpz">
      <div className="shell flex flex-col gap-6 border-b border-line py-10 lg:flex-row lg:items-center lg:justify-between" data-id="element-265" data-mp="2bdhlk8da0cj9">
        <div data-id="element-266" data-mp="2gc1amhn624fu">
          <p className="font-display text-[clamp(1.25rem,1rem+0.6vw,1.75rem)] font-semibold tracking-tight" data-id="element-267" data-mp="2g9f2afsgbkwk">Website tips, no spam.</p>
          <p className="mt-1 text-muted" data-id="element-268" data-mp="3837cp3mg6c7r">Occasional notes on getting more from your website.</p>
        </div>
        <NewsletterForm data-id="element-269" data-mp="2u3piu9uao8rj" />
      </div>

      <div className="shell grid gap-12 py-[clamp(3rem,5vw,6rem)] sm:grid-cols-2 xl:grid-cols-[1.4fr_1fr_1.2fr_1fr]" data-id="element-270" data-mp="2u2eiyl3yzl5p">
        <div data-id="element-271" data-mp="2z43pbng8zang">
          <Logo data-id="element-272" data-mp="1inr5vuvzx2l1" />
          <p className="mt-6 max-w-[34ch] text-muted" data-id="element-273" data-mp="1in7vr0cl7ihk">Modern, professional websites that help businesses stand out, attract customers and grow online.</p>
          <ul className="mt-6 grid gap-2 text-[15px]" data-id="element-274" data-mp="1no5b7567pyfd">
            <li data-id="element-275" data-mp="13kzg6qs81az0">
              <a href={`mailto:${CONTACT.email}`} className="inline-flex min-h-[36px] items-center gap-2 text-fg-2 hover:text-fg" data-id="element-276" data-mp="13jg0b1ah91xr">
                <MailIcon className="h-4 w-4 text-accent-soft" data-id="element-277" data-mp="zl8qkqefl0w2" /> {CONTACT.email}
              </a>
            </li>
            {CONTACT.phones.map(p => <li key={p.href} data-id="element-278" data-mp="ps9uyokioa2y">
                <a href={p.href} className="inline-flex min-h-[36px] items-center gap-2 text-fg-2 hover:text-fg" data-id="element-279" data-mp="pr8gsb87f7h0">
                  <PhoneIcon className="h-4 w-4 text-accent-soft" data-id="element-280" data-mp="krvkz0zcuq2a" /> {p.label}
                </a>
              </li>)}
          </ul>
          <ul className="mt-6 flex gap-2" aria-label="Social media (links coming soon)" data-id="element-281" data-mp="bul7d8z2eou7">
            {SOCIALS.map(s => <li key={s.name} data-id="element-282" data-mp="6w1l17gk7b1b">
                <a href={s.href || undefined} aria-label={`${s.name}${s.href ? "" : " (link coming soon)"}`} aria-disabled={!s.href} className={`grid h-11 w-11 place-items-center rounded-full border border-line-strong font-mono text-xs ${s.href ? "hover:border-white/40" : "cursor-not-allowed opacity-50"}`} data-id="element-283" data-mp="267kstiq4md9e">
                  {socialMarks[s.name]}
                </a>
              </li>)}
          </ul>
        </div>
        <Column title="Studio" links={FOOTER_STUDIO} data-id="element-284" data-mp="2ngnbg6bayezj" />
        <Column title="Services" links={serviceLinks} data-id="element-285" data-mp="2ng3twqpkdsm1" />
        <div className="grid content-start gap-10" data-id="element-286" data-mp="1pty5xmhe5k8x">
          <Column title="Clients" links={FOOTER_CLIENTS} data-id="element-287" data-mp="1pv9avpmkoy1m" />
          <Column title="Legal" links={FOOTER_LEGAL} data-id="element-288" data-mp="1utaq1zgvod7t" />
        </div>
      </div>

      <div className="shell flex flex-col gap-2 border-t border-line py-6 text-sm text-muted lg:flex-row lg:justify-between" data-id="element-289" data-mp="1zqt23yq6z8k1">
        <p data-id="element-290" data-mp="23tpcx39hq0df">© 2026 NEXORA Web Studio. All rights reserved.</p>
        <p data-id="element-291" data-mp="3b6reockkwcq0">Website Design, Marketing by Ad ROI Marketing | Sales Automation CRM by 1Dash.Pro</p>
      </div>
    </footer>;
}